import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { FeatureFlagStore } from '../stores/feature-flag.store';
import { VenueAccessStore } from '../stores/venue-access.store';

/**
 * Holds the dashboard shell until everything that decides what the sidebar shows is known.
 *
 * The Events and Campaigns entries follow their feature flags and Billing follows the venue's
 * access state, and every one of those reads permissively while unknown — so with the shell
 * painting before the requests resolve, an entry the venue cannot use appeared for a beat and
 * then vanished. Awaiting the two loads here means the first frame of the menu is the right one.
 *
 * Never refuses: both stores degrade to their permissive state on a failed request, and this
 * guard only waits for that answer, whichever it is. The loads are idempotent, so the pages that
 * call them later hit the cache rather than the network.
 */
export const navPrerequisitesGuard: CanActivateFn = async () => {
  const featureFlagStore = inject(FeatureFlagStore);
  const venueAccessStore = inject(VenueAccessStore);

  await Promise.all([featureFlagStore.load(), venueAccessStore.load()]);

  return true;
};
